import { createSelector } from '@ngrx/store';
import { AppState } from '../../core/models/appState.model';
import { UserGroups } from '../../web-api-client';

export const selectUserGroups = createSelector(
  (state: AppState) => state.authUserGroups.userGroups,
  (userGroups: UserGroups[] | undefined | null) => userGroups
);
